@import 'src/global/theme-variables';

.rv-container {
  display: flex;
  padding: 16px;
  position: relative;
  border: 1px solid #eee;
  border-radius: 7px;
  flex-direction: column;
  height: 202px;
  line-height: 21px;

  * {
    font-family: Inter, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue',
      Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  }

  .rv-bank-list {
    overflow: auto;
  }
}

.rv-header-container {
  display: flex;
}

.rv-title {
  display: flex;
  color: $secondary;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  text-align: left;
  flex-grow: 1;
  line-height: 1.235;
}

.rv-bank-accounts-ul {
  list-style-type: none;
  font-weight: 400;
  margin: 0;
  padding: 8px 0;
}

.rv-bank-accounts-ul-title {
  padding-top: 8px;
  color: black;
  line-height: 28px;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}

.rv-bank-accounts-item-container {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
}

.rv-bank-accounts-item-name {
  color: #424242;
  font-size: 14px;
  font-weight: 500;
}

.rv-bank-accounts-item-dot {
  margin: 0 16px 8px;
  display: flex;
  flex-grow: 1;
  border-bottom: 1px dashed #9e9e9e;
}

.rv-bank-accounts-item-value {
  text-align: end;
  color: #212121;
  font-size: 14px;
  font-weight: 700;
}
